import { reduceBankHolidays } from './BankHolidayReducer';
import moment from 'moment';
import { BankHolidays } from '../models/APIModels';
import { Address } from '../components/AddressLookup';

export function populateDisabledDays(
  bankHolidays: BankHolidays,
  address: Address | null,
  currentDate: Date,
  initialDisabledDays: any[] | null,
  minDaysBuffer?: number,
) {
  let disabledDays = [];

  let datesToInclude = reduceBankHolidays(bankHolidays!!, address);

  for (const bankHoliday of datesToInclude) {
    const bankHolidayDate = new Date(bankHoliday.date);
    if (bankHolidayDate >= currentDate) {
      bankHolidayDate.setHours(0, 0, 0, 0);
      disabledDays.push(bankHolidayDate);
    }
  }

  let numberOfDays;

  // If minDaysBuffer is provided (e.g., for removals with 7-day buffer), use it
  if (minDaysBuffer !== undefined) {
    numberOfDays = minDaysBuffer;
  } else if (currentDate.getHours() >= 11) {
    // If it is after 11am, the earliest collection is 2 days from now, delivery is 3 days from now
    numberOfDays =
      initialDisabledDays && initialDisabledDays.length > 0 ? 4 : 3;
  } else {
    // If it is before 11am, the earliest collection is 1 day from now, delivery is 2 days from now
    numberOfDays =
      initialDisabledDays && initialDisabledDays.length > 0 ? 3 : 2;
  }

  // Add 2 days to account for weekend
  // 0 = Sunday, 6 = Saturday
  if (currentDate.getDay() + numberOfDays >= 6) {
    numberOfDays += 2;
  }

  // If any of the days between now and the nearest collection date are bank holidays, add an extra disabled day.
  for (let i = 1; i < numberOfDays; i++) {
    let date = new Date(currentDate);
    date.setDate(date.getDate() + i);
    date.setHours(0, 0, 0, 0);
    if (
      disabledDays.find(
        (disabledDate) => disabledDate.getTime() === date.getTime(),
      )
    ) {
      numberOfDays += 1;
    }
  }

  const dateBefore = moment(currentDate.getTime())
    .add(numberOfDays, 'days')
    .toDate();
  dateBefore.setHours(0, 0, 0, 0);

  disabledDays.push({ daysOfWeek: [0, 6] });
  disabledDays.push({ before: dateBefore });

  disabledDays.push({
    from: new Date('2024-12-21'),
    to: new Date('2025-01-05'),
  });

  // Specific unavailable dates for December 2025 and January 2026
  const unavailableDates2025_2026 = [
    new Date('2025-12-22'),
    new Date('2025-12-23'),
    new Date('2025-12-24'),
    new Date('2025-12-29'),
    new Date('2025-12-30'),
    new Date('2025-12-31'),
    new Date('2026-01-02'),
    new Date('2026-01-05'),
  ];

  unavailableDates2025_2026.forEach((date) => {
    date.setHours(0, 0, 0, 0);
    disabledDays.push(date);
  });

  if (initialDisabledDays) {
    disabledDays.push(...initialDisabledDays);
  }

  return disabledDays;
}
